import { apiClient } from '../../../shared/api/client.js';

export const badgeApi = {
  async getBadgeData(uibn: string): Promise<any> {
    return apiClient(`/api/badge/${encodeURIComponent(uibn)}/data`);
  },

  getBadgeSvgUrl(uibn: string, style: 'pill' | 'shield' | 'card' = 'pill', theme: string = 'emerald'): string {
    return `/api/badge/${encodeURIComponent(uibn)}.svg?style=${encodeURIComponent(style)}&theme=${encodeURIComponent(theme)}`;
  },

  getEmbedUrl(uibn: string, theme: string = 'light', compact: boolean = false): string {
    return `/api/badge/embed/${encodeURIComponent(uibn)}?theme=${encodeURIComponent(theme)}&compact=${compact}`;
  },
};
